var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { deepcopy } from '../../utils/deepmerge';
import { serializeProperty } from '../../utils/serialize-property';
import { deserializeProperty } from '../../utils/deserialize-property';
var PropertyMapping = /** @class */ (function () {
    function PropertyMapping(properties) {
        this.properties = [];
        if (Array.isArray(properties)) {
            this.properties = properties;
        }
        else {
            for (var key in properties) {
                if (properties.hasOwnProperty(key)) {
                    var control = properties[key].build();
                    this.properties.push(control);
                }
            }
        }
    }
    PropertyMapping.prototype.deserialize = function (original) {
        var e_1, _a;
        var returnValue = {};
        try {
            for (var _b = __values(this.properties), _c = _b.next(); !_c.done; _c = _b.next()) {
                var property = _c.value;
                deserializeProperty(returnValue, property, original);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return returnValue;
    };
    PropertyMapping.prototype.resolve = function (form) {
        return this.serialize({}, form);
    };
    PropertyMapping.prototype.serialize = function (o, form) {
        var e_2, _a;
        var copy = o != null ? deepcopy(o) : {};
        try {
            // Create the destination object
            for (var _b = __values(this.properties), _c = _b.next(); !_c.done; _c = _b.next()) {
                var property = _c.value;
                serializeProperty(property, copy, form);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // Merge the source object with the destination object
        return copy;
    };
    return PropertyMapping;
}());
export { PropertyMapping };
//# sourceMappingURL=property-mapping.js.map